import { render, staticRenderFns } from "./Imo.vue?vue&type=template&id=8c9ca458&scoped=true"
import script from "./Imo.vue?vue&type=script&lang=js"
export * from "./Imo.vue?vue&type=script&lang=js"
import style0 from "./Imo.vue?vue&type=style&index=0&id=8c9ca458&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9ca458",
  null
  
)

export default component.exports